export enum PageKey {
  /** 主页 */
  PRIME = 'prime',
  /** 帮助中心 */
  SUPPORT = 'support',
  /** 首页banner详情 */
  HOME_BANNER_DETAIL = 'home-banner-detail',
  /** 最近作品 */
  HOME_RECENTLY = 'home-recently',
  /** 我的收藏 */
  HOME_COLLECTION = 'home-collection',
  /** 个人空间 */
  HOME_PERSONAL = 'home-personal',
  /** 团队空间 */
  HOME_TEAM = 'home-team',
  /** 品牌空间 */
  HOME_BRAND = 'home-brand',
  /** 速影（Haier） */
  SUYING = 'suying',
  /** 品牌 */
  BRAND = 'brand',
  /** 落地页 */
  LANDING = 'landing',
  /** 首页 */
  HOME = 'home',
  /** AI 视频创作页 */
  AI_AVATAR_VIDEO_GENERATION = 'ai-avatar-video-generation',
  /** AI PPT 页面 */
  AI_PPT = 'ai-ppt',
  /** API 页面 */
  API = 'api',
  /** 模板中心 */
  TEMPLATE = 'template',
  /** 模板详情 */
  TEMPLATE_INFO = 'template-info',
  /** 模板详情-移动端 */
  TEMPLATE_MOBILE_INFO = 'template-info-mobile',
  /** tag搜索结果页 */
  TEMPLATE_TAG = 'template-tag',
  /** 模板行业场景 */
  TEMPLATE_INDUSTRY_SCENE = 'template-industry-scene',
  /** 应用场景 */
  SCENARIOS = 'scenarios',
  /** 付费订阅 */
  SUBSCRIBE = 'subscribe',
  /** 教程中心 */
  TUTORIAL = 'tutorial',
  /** 教程详情 */
  TUTORIAL_INFO = 'tutorial-info',
  /** 创作指南 */
  PRODUCT_GUIDE = 'product-guide',
  /** 帮助中心 */
  HELP_CENTER = 'help-center',
  /** 帮助中心-预览 */
  HELP_CENTER_PREVIEW = 'help-center-preview',
  /** 帮助中心详情 */
  HELP_CENTER_DETAIL = 'help-center-detail',
  /** 博客 */
  BLOG = 'blog',
  /** 最近作品 */
  RECENTLY_WORKS = 'recent-works',
  /** 我的收藏 */
  MY_COLLECTION = 'my-collection',
  /** 个人空间 */
  PERSONAL_SPACE = 'personal-space',
  /** 团队空间 */
  TEAM_SPACE = 'team-space',
  /** 品牌管理 */
  BRAND_MANAGE = 'brand-manage',
  /** 品牌管理 */
  LAB = 'lab',
  /** 账号管理 */
  CENTER_ACCOUNT = 'center-account',
  /** 成员管理 */
  CENTER_MEMBER = 'center-member',
  /** 消耗记录 */
  CENTER_CONSUME = 'center-consume',
  /** 权益管理 */
  CENTER_EQUITY = 'center-equity',
  /** 订单管理 */
  CENTER_ORDER = 'center-order',
  /** 开票管理 */
  CENTER_ORDER_INVOICE = 'center-order-invoice',
  /** 个人主页 */
  PERSONAL_PAGE = 'personal-page',
  /** 登录 */
  LOGIN = 'login',
  /** 绑定飞书 */
  LOGIN_FEISHU = 'login-feishu',
  /** 账号认证 */
  ACCOUNT_VERIFY = 'account-verify',
  /** 账号认证结果 */
  ACCOUNT_VERIFY_RESULT = 'account-verify-result',
  /** 第三方平台授权 */
  AUTHORIZE = 'authorize',
  /** 第三方授权登录 */
  THIRD_AUTH_LOGIN = 'third-auth-login',
  /** 成员管理 */
  MEMBER_MANAGE = 'member-manage',
  /** 团队邀请 */
  INVITE = 'invite',
  /** 申请试用 */
  APPLY_CONTACT = 'apply-contact',
  /** 拉新 */
  PULL_NEW = 'pull-new',
  /** 国风创作比赛 */
  NATIONAL_RACE = 'national-race',
  /** 山东5g创新大赛活动 */
  INNOVATION_5G = '5GInnovation',
  /** 团队体验版创建 */
  TEAM_TASTE_CREATE = 'team-taste-create',
  /** 团队入门版创建 */
  TEAM_STARTER_CREATE = 'team-starter-create',
  /** 支付的回调页面 */
  PAYMENT_RESULT = 'payment-result',
  /** 取消订阅成功 */
  CANCEL_RESULT = 'cancel-result',
  /** 全部行业 */
  INDUSTRY = 'industry',
  /** 行业详情 */
  INDUSTRY_DETAIL = 'industry-detail',
  /** 客户案例 */
  CASE = 'case',
  /** 客户案例详情 */
  CASE_DETAIL = 'case-detail',
  /** 最佳实践 */
  BEST_PRACTICE = 'best-practice',
  /** PPT世界 */
  PPT_WORLD = 'ppt-world',
  /** 注册感谢 */
  THANKS = 'thanks',
  /** 成片详情 */
  PIECES_DETAIL = 'pieces-detail',
  /** 授权书签署 */
  ACCREDIT = 'accredit',
  /** 没有权限 */
  NO_PERMISSION = 'no-permission',
  /** 没有找到页面 */
  NOT_FOUND = 'not-found',
  /** 联系我们（海外版） */
  CONTACT_US = 'contact-us',
  /** 图生人脸 */
  PGC = 'pgc',
  /** 全站搜索 */
  SITE_SEARCH = 'search-site',
  /** 新数字人集合页 */
  AI_AVATAR = '3d-ai-avatar',
  /** 原数字人集合页 链接替换 */
  AVATAR_LIBRARY = 'avatar-library',
  /** 数字人集合页 */
  CHARACTER = 'character',
  /** 数字人集合页-行业-应用场景 */
  CHARACTER_INDUSTRY_SCENE = 'character-industry-scene',
  /** 数字人详情页面 */
  CHARACTER_DETAIL = 'character-detail',
  /** 魔珐学院 */
  ACADEMY = 'academy',
  /** 魔珐学院-收藏 */
  ACADEMY_COLLECTION = 'academy-collection',
  /** 魔珐学院-详情 */
  ACADEMY_DETAIL = 'academy-detail',
  /** 新闻 */
  NEWS = 'news',
  /** Lab实验室分享落地页 */
  LAB_SHARE_LANDING = 'lab-share-landing',
  /** 场景详情 */
  SCENE_DETAILS = 'scene-details',

  /** SSO 登录 */
  SSO_LOGIN = 'sso-login',
  /** 音色介绍页 */
  AI_VOICE = 'ai-voice',
  /** 场景介绍页 */
  SCENE_INTRODUCTION = 'scene-introduction',
  /** chat ppt */
  // CHAT_PPT = 'chat-ppt',
  /** PPT Speak */
  PPT_SPEAK = 'ppt-speak',

  /** 注册/登录成功 */
  WELCOME = 'welcome',
  /** 新春活动 */
  NEW_YEAR = 'new-year',
  /** PPT/PDF转视频 */
  PPT_OR_PDF_TO_VIDEO = 'ppt-or-pdf-to-video',
}
